import { render, staticRenderFns } from "./compareschers.vue?vue&type=template&id=97806618&scoped=true"
import script from "./compareschers.vue?vue&type=script&lang=js"
export * from "./compareschers.vue?vue&type=script&lang=js"
import style0 from "./compareschers.vue?vue&type=style&index=0&id=97806618&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97806618",
  null
  
)

export default component.exports